<template>
  <van-pull-refresh
    v-model="refreshing"
    class="page-pull-refresh"
    @refresh="onRefresh"
  >
    <div class="fence-alarm">
    <!--section class="page-hero">
      <div class="page-hero__copy">
        <span class="page-hero__eyebrow">围栏告警</span>
        <h2>告警甄别与处理中心</h2>
        <p>统一查看时间、设备、事件类型与处理状态，让告警信息在手机和桌面上都更容易判断与闭环。</p>
      </div>
      <div class="page-hero__meta">
        <span class="meta-pill">总报警 {{ totalCount }}</span>
        <span class="meta-pill meta-pill--soft">未甄别 {{ unverifiedCount }}</span>
      </div>
    </section-->

    <div class="filter-section">
      <!-- <van-search
        v-model="filters.bindingTK"
        placeholder="输入设备名称搜索"
        @search="onSearch"
        @clear="onClear"
        show-action
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search> -->

      <!-- 日期范围选择器 -->
      <div class="date-range-display">
        <van-field
          readonly
          clickable
          label="日期范围"
          :value="formatDateRange()"
          placeholder="选择日期范围"
          @click="openDateRangePicker"
          style="flex:1"
        />
        <span v-if="filters.dateRange.length" class="clear-date" @click="resetDateRange">重置</span>
      </div>
      
      <!-- 设备选择器 -->
      <div class="device-selector">
        <van-field
          readonly
          clickable
          label="梯口设备"
          :value="filters.deviceName"
          placeholder="选择梯口设备"
          @click="openDevicePicker"
          style="flex:1"
        />
        <span v-if="filters.deviceId" class="clear-device" @click="resetDeviceFilter">重置</span>
      </div>
      <van-popup v-model="showDevicePicker" position="bottom" :style="{ height: '70%' }" round>
        <div class="popup-header">
          <h3>选择设备</h3>
          <van-icon name="cross" @click="showDevicePicker = false" />
        </div>
        <div class="device-list">
          <div class="device-selection">
            <h4>可用设备列表</h4>
            <van-loading v-if="devicesLoading" type="spinner" color="#667eea" class="loading-center">
              加载设备中...
            </van-loading>
            <van-radio-group v-model="tempSelectedDevice" v-else>
              <van-cell-group>
                <van-cell
                  v-for="device in availableDevices"
                  :key="device.id"
                  :title="device.deviceName"
                  :label="`设备编号: ${device.deviceSN} | 所属码头: ${getPortName(device.portCode)}`"
                  clickable
                  @click="tempSelectedDevice = device.id"
                >
                  <template #icon>
                    <van-icon name="cluster-o" class="device-icon" />
                  </template>
                  <template #right-icon>
                    <van-radio :name="device.id" />
                  </template>
                  <template #extra>
                    <van-tag :type="device.isOnline ? 'success' : 'warning'" size="small">
                      {{ device.isOnline ? '在线' : '离线' }}
                    </van-tag>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
            <van-empty
              v-if="!devicesLoading && availableDevices.length === 0"
              description="暂无可用设备"
            >
              <template #image>
                <svg width="120" height="80" viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="60" cy="40" r="20" fill="none" stroke="#d9d9d9" stroke-width="3"/>
                  <path d="M75 55 L85 65" stroke="#d9d9d9" stroke-width="3" stroke-linecap="round"/>
                  <circle cx="60" cy="40" r="12" fill="none" stroke="#d9d9d9" stroke-width="1.5" stroke-dasharray="3 3"/>
                </svg>
              </template>
            </van-empty>
          </div>
          <div class="binding-actions">
            <van-button
              type="primary"
              block
              round
              :disabled="!tempSelectedDevice"
              @click="onDeviceConfirm"
            >
              确定选择
            </van-button>
          </div>
        </div>
      </van-popup>
      
      
      
      <!-- 事件类型和处理状态选择器同一行 -->
    
        <div class="type-selector">
          <van-field
            readonly
            clickable
            label="报警类型"
            :value="getTypeText(filters.type)"
            placeholder="选择报警类型"
            @click="openTypePicker"
            style="width:100%"
          />
          <span v-if="filters.type !== '全部类型'" class="clear-type" @click="resetTypeFilter">重置</span>
        </div>
        <!-- <div class="status-selector">
          <van-field
            readonly
            clickable
            label="处理状态"
            :value="getHandleStateText(filters.handleState)"
            placeholder="选择处理状态"
            @click="openStatusPicker"
            style="width:100%"
          />
          <span v-if="filters.handleState !== '全部状态'" class="clear-status" @click="resetStatusFilter">重置</span>
        </div> -->
     
    </div>

    <!-- 统计信息 -->
    <div class="stats-section">
      <div class="stat-item" :class="{ active: activeStat === 'all' }" @click="onStatClick('all')">
        <span class="stat-label">总报警数</span>
        <span class="stat-value stat-primary">{{ totalCount }}</span>
      </div>      
      <div class="stat-item" :class="{ active: activeStat === 'verified' }" @click="onStatClick('verified')">
        <span class="stat-label">已甄别</span>
        <span class="stat-value stat-verified">{{ verifiedCount }}</span>
      </div>
      <div class="stat-item" :class="{ active: activeStat === 'unverified' }" @click="onStatClick('unverified')">
        <span class="stat-label">未甄别</span>
        <span class="stat-value stat-unverified">{{ unverifiedCount }}</span>
      </div>
      <div class="stat-item" :class="{ active: activeStat === 'normal' }" @click="onStatClick('normal')">
        <span class="stat-label">正常</span>
        <span class="stat-value stat-normal">{{ normalCount }}</span>
      </div>
      <div class="stat-item" :class="{ active: activeStat === 'abnormal' }" @click="onStatClick('abnormal')">
        <span class="stat-label">异常</span>
        <span class="stat-value stat-abnormal">{{ abnormalCount }}</span>
      </div>
    </div>

    <!-- 报警列表 -->
    <div class="alarm-list-section">
      <van-loading v-if="loading" type="spinner" color="#667eea" class="loading-center">加载中...</van-loading>
      <van-list
        v-else
        v-model="loadingMore"
        :finished="finished"
        :offset="120"
        finished-text="没有更多了"
        @load="onLoadMore"
        class="alarm-van-list"
      >
        <div class="alarm-list">
          <van-card
            v-for="alarm in alarms"
            :key="alarm.id"
            class="alarm-card"
            :class="{ 'unverified-card': alarm.handleState === 0 }"
            >
            <template #thumb>
              <div class="alarm-thumb" @click="previewPhoto(alarm.photo)">
                <img v-if="alarm.photo" :src="alarm.photo" class="alarm-photo" />
                <div v-else class="no-photo">无照片</div>
              </div>
            </template>
            
            <template #title>
              <div class="alarm-header">
                <span class="alarm-title">{{ alarm.bindingTK }}</span>
                <span class="alarm-time-abs">{{ formatAlarmTime(alarm.alarmTime) }}</span>
              </div>
            </template>
            
            <template #desc>
              <div class="alarm-content">
                <div class="alarm-details">
                  <div class="detail-row">
                    <span class="label">人员姓名：</span>
                    <span class="value">{{ alarm.name || alarm.personName || '-' }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="label">证件号码：</span>
                    <span class="value">{{ alarm.docNo || '-' }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="label">码头名称：</span>
                    <span class="value">{{ getPortName(alarm.portCode) }}</span>
                  </div>
                  <!--div class="detail-row">
                    <span class="label">报警类型：</span>
                    <van-tag :type="getAlarmTypeTag(alarm.type)" size="small">
                      {{ getAlarmTypeText(alarm.type) }}
                    </van-tag>
                  </div-->
                  <!--div class="detail-row">
                    <span class="label">处理状态：</span>
                    <van-tag :type="getHandleStateTag(alarm.handleState)" size="small">
                      {{ getHandleStateText(alarm.handleState) }}
                    </van-tag>
                  </div-->
                  <div v-if="alarm.handleState > 0" class="detail-row">
                    <span class="label">处理时间：</span>
                    <span class="value">{{ formatHandleTime(alarm.handleTime) }}</span>
                  </div>
                  <div v-if="alarm.handleUserName" class="detail-row">
                    <span class="label">处理人员：</span>
                    <span class="value">{{ alarm.handleUserName }}</span>
                  </div>
                </div>
              </div>
            </template>
            
            <template #footer>
              <div class="alarm-footer-row">
                <div class="footer-col footer-col-left">
                  <van-button
                    v-if="alarm.video"
                    size="mini"
                    type="primary"
                    @click="playVideo(alarm)"
                    :loading="alarm.videoLoading"
                    class="alarm-btn"
                  >
                    <van-icon name="play-circle-o" />
                    播放视频
                  </van-button>
                </div>
                <div class="footer-col footer-col-center">
                  <van-tag :type="getAlarmTypeTag(alarm.type)" size="small" class="alarm-type-tag-footer">
                    {{ getAlarmTypeText(alarm.type) }}
                  </van-tag>
                </div>
                <div class="footer-col footer-col-center">
                  <van-tag :type="getHandleStateTag(alarm.handleState)" size="small" class="alarm-type-tag-footer">
                    {{ getHandleStateText(alarm.handleState) }}
                  </van-tag>
                </div>
                <div class="footer-col footer-col-right">
                  <van-button                
                    size="mini"
                    type="warning"
                    @click="handleAlarm(alarm)"
                    :loading="alarm.handleLoading"
                    class="alarm-btn handle-btn"
                  >
                    处理
                  </van-button>
                </div>
              </div>
            </template>
          </van-card>
        </div>
      </van-list>
    </div>

    <!-- 视频播放弹窗 -->
    <!-- 图片预览弹窗 -->
    <van-image-preview
      v-model="showPhotoPreview"
      :images="previewImages"
      :start-position="0"
      :closeable="true"
    >
    </van-image-preview>

    <van-popup
      v-model="showVideoPlayer"
      position="center"
      :style="{ width: '90vw', height: '60vh', borderRadius: '12px' }"
      round
    >
      <div class="video-player-container">
        <div class="video-header">
          <h3>{{ currentAlarm?.bindingTK }} - 报警视频</h3>
          <van-icon name="cross" @click="closeVideo" />
        </div>
        
        <div class="video-content">
          <video
            v-if="currentVideoUrl"
            :src="currentVideoUrl"
            controls
            autoplay
            class="video-player"
            @error="onVideoError"
          >
            您的浏览器不支持视频播放
          </video>
        </div>
      </div>
    </van-popup>

    <!-- 处理确认弹窗 -->
    <van-popup
      v-model="showHandleDialog"
      position="bottom"
      :style="{ height: '50%' }"
      round
    >
      <div class="handle-dialog">
        <div class="handle-header">
          <h3>处理报警</h3>
          <van-icon name="cross" @click="showHandleDialog = false" />
        </div>
        
        <div class="handle-content">
          <div class="alarm-summary">
            <h4>{{ currentAlarm?.bindingTK }}</h4>
            <p>{{ formatAlarmTime(currentAlarm?.alarmTime) }} - {{ getPortName(currentAlarm?.portCode) }}</p>
          </div>
          
          <van-form @submit="confirmHandle">
            <van-field
              v-model="handleForm.result"
              name="result"
              label="处理结果"
              placeholder="请选择处理结果"
              readonly
              @click="showResultPicker = true"
              :rules="[{ required: true, message: '请选择处理结果' }]"
            />
            
            <van-field
              v-model="handleForm.remark"
              name="remark"
              label="备注说明"
              type="textarea"
              placeholder="请输入处理说明（可选）"
              rows="3"
            />
            
            <div class="handle-actions">
              <van-button
                round
                block
                type="primary"
                native-type="submit"
                :loading="handleSubmitting"
              >
                确认处理
              </van-button>
            </div>
          </van-form>
        </div>
      </div>
    </van-popup>

    <!-- 处理结果选择弹窗 -->
    <van-popup v-model="showResultPicker" position="bottom">
      <van-picker
        :columns="handleResultOptions"
        show-toolbar
        title="选择处理结果"
        @confirm="onResultConfirm"
        @cancel="showResultPicker = false"
      />
    </van-popup>

    <!-- 日期选择弹窗 -->
    <van-popup v-model="showDatePicker" position="bottom" @close="onDateRangePopupClose">
      <div style="padding: 16px;">
        <div style="margin-bottom: 8px;">开始日期</div>
        <van-datetime-picker
          v-model="tempStartDate"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          title="选择开始日期"
          :show-toolbar="false"
        />
        <div style="margin: 16px 0 8px;">结束日期</div>
        <van-datetime-picker
          v-model="tempEndDate"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          title="选择结束日期"
          :show-toolbar="false"
        />
        <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px;">
          <van-button size="small" @click="showDatePicker = false">取消</van-button>
          <van-button size="small" type="primary" @click="onDateRangeConfirm">确定</van-button>
        </div>
      </div>
    </van-popup>
    
    <!-- 事件类型选择弹窗 -->
    <van-popup v-model="showTypePicker" position="bottom">
      <van-picker
        :columns="typeOptions"
        show-toolbar
        title="选择报警类型"
        @confirm="onTypeConfirm"
        @cancel="showTypePicker = false"
      />
    </van-popup>
    
    <!-- 处理状态选择弹窗 -->
    <van-popup v-model="showStatusPicker" position="bottom">
      <van-picker
        :columns="statusOptions"
        show-toolbar
        title="选择处理状态"
        @confirm="onStatusConfirm"
        @cancel="showStatusPicker = false"
      />
    </van-popup>

    <!-- 空状态 -->
    <van-empty
      v-if="!loading && alarms.length === 0"
      description="暂无报警记录"
    >
      <template #image>
        <svg width="120" height="80" viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="60" cy="40" r="20" fill="none" stroke="#d9d9d9" stroke-width="3"/>
          <path d="M75 55 L85 65" stroke="#d9d9d9" stroke-width="3" stroke-linecap="round"/>
          <circle cx="60" cy="40" r="12" fill="none" stroke="#d9d9d9" stroke-width="1.5" stroke-dasharray="3 3"/>
        </svg>
      </template>
    </van-empty>
    </div>
  </van-pull-refresh>
</template>

<script>
import axios from '@/utils/request'
import { fetchMultiDic, default as globalDic } from '@/utils/dic'

export default {
  name: 'FenceAlarm',
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return {
        loading: false,
        refreshing: false,
        loadingMore: false,
        finished: false,
        pageIndex: 1,
        pageSize: 20,
        filters: {
          portCode: '',
          bindingTK: '',
          deviceId: '',
          deviceName: '',
          type: '全部类型',
          handleState: '全部状态',
          dateRange: [today, today]
      },
      showVideoPlayer: false,
      showPhotoPreview: false,
      previewImages: [],
      showHandleDialog: false,
      showResultPicker: false,
      showDatePicker: false,
      showTypePicker: false,
      showStatusPicker: false,
      showDevicePicker: false,
      availableDevices: [],
      devicesLoading: false,
      tempSelectedDevice: '',
      currentAlarm: null,
      currentVideoUrl: '',
      handleSubmitting: false,
      tempStartDate: new Date(today),
      tempEndDate: new Date(today),
      minDate: new Date(2000, 0, 1),
      maxDate: now,
      handleForm: {
        result: '正常',
        remark: ''
      },

      statusOptions: ['全部状态', '未处理', '已处理（正常）', '已处理（异常）'],
      handleResultOptions: ['正常', '异常'],
      alarms: [],
      activeStat: 'all', // 新增：当前激活的统计项
      totalCount: 0,
      verifiedCount: 0,
      unverifiedCount: 0,
      normalCount: 0,
      abnormalCount: 0,
    };
  },
  
  computed: {
    typeOptions() {
      const options = ['全部类型'];
      if (globalDic.D_AlarmType && globalDic.D_AlarmType.length > 0) {
        globalDic.D_AlarmType.forEach(item => {
          options.push(item.description);
        });
      }
      return options;
    }
  },
  
  methods: {
    getEffectiveHandleState() {
      if (this.activeStat === 'unverified') return 0;
      if (this.activeStat === 'normal') return 1;
      if (this.activeStat === 'abnormal') return 2;
      if (this.activeStat === 'verified') return 3;
      return null;
    },
    async fetchAlarms({ reset = false } = {}) {
      if (reset) {
        this.pageIndex = 1;
        this.finished = false;
        this.alarms = [];
        this.loading = true;
      } else if (this.finished) {
        return;
      } else {
        this.loadingMore = true;
      }
      try {
        const typeMap = { '全部类型': -99 };
        if (globalDic.D_AlarmType && globalDic.D_AlarmType.length > 0) {
          globalDic.D_AlarmType.forEach(item => {
            typeMap[item.description] = Number(item.code);
          });
        }
        const statusMap = { '全部状态': -99, '未处理': 0, '已处理（正常）': 1, '已处理（异常）': 2 };
        const params = {
          portCode: this.filters.portCode,
          bindingTK: this.filters.deviceName,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        };
        if (this.filters.type && typeMap[this.filters.type] !== undefined) {
          params.type = typeMap[this.filters.type];
        }
        const effectiveHandleState = this.getEffectiveHandleState();
        if (effectiveHandleState !== null) {
          params.handleState = effectiveHandleState;
        } else if (this.filters.handleState && statusMap[this.filters.handleState] !== undefined) {
          params.handleState = statusMap[this.filters.handleState];
        }
        if (this.filters.dateRange.length === 2) {
          const getDayStartISOString = date => {
            const d = new Date(date);
            d.setHours(0, 0, 0, 0);
            d.setHours(d.getHours() + 8);
            return d.toISOString();
          };
          const getDayEndISOString = date => {
            const d = new Date(date);
            d.setHours(23, 59, 59, 999);
            d.setHours(d.getHours() + 8);
            return d.toISOString();
          };
          params.startTime = getDayStartISOString(this.filters.dateRange[0]);
          params.endTime = getDayEndISOString(this.filters.dateRange[1]);
        }
        const res = await axios.post('/api/AlarmRecord/Query', params);
        if (res && res.data && res.data.success) {
          const result = res.data.data || {};
          const items = result.items || [];
          this.alarms = reset ? items : this.alarms.concat(items);
          this.totalCount = Number(result.totalCount || 0);
          this.verifiedCount = Number(result.verifiedCount || 0);
          this.unverifiedCount = Number(result.unverifiedCount || 0);
          this.normalCount = Number(result.normalCount || 0);
          this.abnormalCount = Number(result.abnormalCount || 0);
          this.finished = !!result.hasMore === false;
          if (items.length > 0) {
            this.pageIndex += 1;
          }
        } else {
          this.$toast.fail(res.data.message || '查询失败');
          if (reset) {
            this.alarms = [];
            this.totalCount = 0;
            this.verifiedCount = 0;
            this.unverifiedCount = 0;
            this.normalCount = 0;
            this.abnormalCount = 0;
          }
          this.finished = true;
        }
      } catch (err) {
        this.$toast.fail('查询失败，请检查网络');
        if (reset) {
          this.alarms = [];
          this.totalCount = 0;
          this.verifiedCount = 0;
          this.unverifiedCount = 0;
          this.normalCount = 0;
          this.abnormalCount = 0;
        }
        this.finished = true;
      } finally {
        this.loading = false;
        this.loadingMore = false;
      }
    },
    onLoadMore() {
      this.fetchAlarms();
    },
    async onRefresh() {
      try {
        await this.fetchAlarms({ reset: true });
      } finally {
        this.refreshing = false;
      }
    },
    
    onSearch() {
      this.fetchAlarms({ reset: true });
    },
    
    onClear() {
      this.filters.bindingTK = '';
      this.fetchAlarms({ reset: true });
    },
    
    getAlarmTypeTag(type) {
      const t = Number(type);
      if (t === 1 || t === 2) return 'warning';
      return 'danger';
    },
    
    getAlarmTypeText(type) {
      if (type === undefined || type === null) return '未知类型';
      if (globalDic.D_AlarmType && globalDic.D_AlarmType.length > 0) {
        const item = globalDic.D_AlarmType.find(d => String(d.code) === String(type));
        if (item) return item.description;
      }
      return '未知类型';
    },
    
    getHandleStateTag(state) {
      const stateMap = {
        0: 'warning',
        1: 'success',
        2: 'danger'
      };
      return stateMap[state] || 'default';
    },
    

    
    formatAlarmTime(time) {
      if (!time || time === '0001-01-01T00:00:00') return '-';
      const d = new Date(time);
      return d.toLocaleString('zh-CN');
    },
    
    formatHandleTime(time) {
      if (!time || time === '1900-01-01T00:00:00') return '-';
      const d = new Date(time);
      return d.toLocaleString('zh-CN');
    },
    
    getPortName(portCode) {
      if (!portCode) return '';
      if (!globalDic.D_Port || globalDic.D_Port.length === 0) return portCode;
      const port = globalDic.D_Port.find(item => item.code === portCode);
      return port ? port.description : portCode;
    },
    
    // 日期选择相关方法
    openDateRangePicker() {
      if (this.filters.dateRange.length === 2) {
        this.tempStartDate = new Date(this.filters.dateRange[0]);
        this.tempEndDate = new Date(this.filters.dateRange[1]);
      } else {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        this.tempStartDate = today;
        this.tempEndDate = today;
      }
      this.showDatePicker = true;
    },
    
    onDateRangeConfirm() {
      // 结束日期不能小于开始日期
      if (this.tempEndDate < this.tempStartDate) {
        this.$toast.fail('结束日期不能早于开始日期');
        return;
      }
      this.filters.dateRange = [this.tempStartDate, this.tempEndDate];
      this.showDatePicker = false;
      this.fetchAlarms({ reset: true });
    },
    
    resetDateRange() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      this.filters.dateRange = [today, today];
      this.tempStartDate = new Date(today);
      this.tempEndDate = new Date(today);
      this.maxDate = now;
      this.fetchAlarms({ reset: true });
    },
    
    formatDateRange() {
      if (this.filters.dateRange.length === 2) {
        const [start, end] = this.filters.dateRange;
        const format = d => {
          if (!d) return '';
          const date = new Date(d);
          return date.toLocaleDateString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit' });
        };
        return `${format(start)}~${format(end)}`;
      }
      return '';
    },
    
    onDateRangePopupClose() {
      // 关闭弹窗时同步选中的日期
      if (this.tempEndDate < this.tempStartDate) {
        this.$toast.fail('结束日期不能早于开始日期');
        return;
      }
      this.filters.dateRange = [this.tempStartDate, this.tempEndDate];
      this.fetchAlarms({ reset: true });
    },
    
    // 事件类型选择相关方法
    openTypePicker() {
      this.showTypePicker = true;
    },
    onTypeConfirm(value) {
      this.filters.type = value;
      this.showTypePicker = false;
      this.fetchAlarms({ reset: true });
    },
    resetTypeFilter() {
      this.filters.type = '全部类型';
      this.fetchAlarms({ reset: true });
    },
    getTypeText(type) {
      return type || '全部类型';
    },
    // 处理状态选择相关方法
    openStatusPicker() {
      this.showStatusPicker = true;
    },
    onStatusConfirm(value) {
      this.filters.handleState = value;
      this.showStatusPicker = false;
      this.fetchAlarms({ reset: true });
    },
    resetStatusFilter() {
      this.filters.handleState = '全部状态';
      this.fetchAlarms({ reset: true });
    },
    getHandleStateText(state) {
      if (state === 0 || state === '未处理') return '未处理';
      if (state === 1 || state === '已处理（正常）') return '已处理（正常）';
      if (state === 2 || state === '已处理（异常）') return '已处理（异常）';
      return state || '全部状态';
    },
    
    playVideo(alarm) {
      if (!alarm.video) {
        this.$toast.fail('该报警暂无视频');
        return;
      }
      alarm.videoLoading = true;
      this.currentAlarm = alarm;
      this.currentVideoUrl = alarm.video;
      this.showVideoPlayer = true;
      alarm.videoLoading = false;
    },
    
    closeVideo() {
      this.showVideoPlayer = false;
      this.currentAlarm = null;
      this.currentVideoUrl = '';
    },

    previewPhoto(photoUrl) {
      if (!photoUrl) {
        this.$toast.fail('照片链接无效');
        return;
      }
      this.previewImages = [photoUrl];
      this.showPhotoPreview = true;
    },

    onVideoError() {
      this.$toast.fail('视频加载失败，请检查网络连接');
      this.showVideoPlayer = false;
    },
    
    handleAlarm(alarm) {
      this.currentAlarm = alarm;
      this.handleForm = {
        result: '正常',
        remark: ''
      };
      this.showHandleDialog = true;
    },
    
    // 处理结果选择相关方法
    onResultConfirm(value) {
      this.handleForm.result = value;
      this.showResultPicker = false;
    },
    
    async confirmHandle() {
      this.handleSubmitting = true;
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        const handleUserId = userInfo.userId || userInfo.id || '';
        console.log('[处理报警] 当前登录用户 userInfo:', userInfo);
        console.log('[处理报警] handleUserId:', handleUserId);
        const result = this.handleForm.result === '正常' ? 1 : 2;
        const params = {
          id: this.currentAlarm.id,
          handleState: result,
          note: this.handleForm.remark,
          handleUserId
        };
        console.log('[处理报警] 请求参数:', params);
        const res = await axios.post('/api/AlarmRecord/UpdateHandleState', params);
        console.log('[处理报警] 接口返回:', res);
        if (res && res.data && res.data.success) {
          this.$toast.success('处理完成');
          this.showHandleDialog = false;
          this.handleSubmitting = false;
          this.fetchAlarms({ reset: true });
        } else {
          this.$toast.fail(res.data.message || '处理失败');
          this.handleSubmitting = false;
        }
      } catch (err) {
        console.error('[处理报警] 网络异常:', err);
        this.$toast.fail('处理失败，请检查网络');
        this.handleSubmitting = false;
      }
    },
    
    viewDetails(alarm) {
      this.$toast(`查看${alarm.type}详情`);
    },

    onStatClick(type) {
      this.activeStat = this.activeStat === type ? 'all' : type;
      this.fetchAlarms({ reset: true });
    },

    async fetchAvailableDevices() {
      this.devicesLoading = true;
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        let params = {};
        if (userInfo.roleID !== 0 && userInfo.portCode) {
          params.portCode = userInfo.portCode;
        }
        const res = await axios.post('/api/Device/Query', params);
        if (res && res.data && res.data.success) {
          this.availableDevices = res.data.data || [];
        } else {
          this.$toast.fail(res.data.message || '获取设备列表失败');
          this.availableDevices = [];
        }
      } catch (err) {
        this.$toast.fail('获取设备列表失败，请检查网络连接');
        this.availableDevices = [];
      } finally {
        this.devicesLoading = false;
      }
    },
    async openDevicePicker() {
      if (this.availableDevices.length === 0) {
        await this.fetchAvailableDevices();
      }
      this.tempSelectedDevice = this.filters.deviceId;
      this.showDevicePicker = true;
    },
    onDeviceConfirm() {
      //this.filters.deviceId = this.tempSelectedDevice;
      this.filters.deviceId = this.tempSelectedDevice;
      // 根据选中的设备ID获取设备名称
      const selectedDevice = this.availableDevices.find(d => d.id === this.tempSelectedDevice);
      this.filters.deviceName = selectedDevice ? selectedDevice.deviceName : '';
      //this.selectedDeviceName  = this.filters.deviceName;
      console.log('[处理报警] 选中的设备:', this.filters.deviceName);
      this.showDevicePicker = false;
      this.fetchAlarms({ reset: true });
    },
    resetDeviceFilter() {
      this.filters.deviceId = '';
      this.filters.deviceName = '';
      this.tempSelectedDevice = '';
      this.fetchAlarms({ reset: true });
    },
  },
  
  async mounted() {
    if (!globalDic.D_AlarmType || globalDic.D_AlarmType.length === 0) {
      await fetchMultiDic(['D_Role', 'D_Port', 'D_AlarmType']);
    }
    await this.fetchAlarms({ reset: true });
    // 如果有已选设备ID，自动同步设备名（如刷新页面后）
    if (this.filters.deviceId && !this.filters.deviceName) {
      if (this.availableDevices.length === 0) {
        await this.fetchAvailableDevices();
      }
      const dev = this.availableDevices.find(d => d.id === this.filters.deviceId);
      if (dev) this.filters.deviceName = dev.deviceName;
    }
  }
};
</script>

<style scoped>
.fence-alarm {
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-height: 100%;
}

.page-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 24px;
  border-radius: 28px;
  color: #fff;
  background: linear-gradient(135deg, var(--surface-strong) 0%, var(--brand-500) 65%, #6caeff 100%);
  box-shadow: 0 22px 50px rgba(15, 79, 185, 0.2);
}

.page-hero__copy h2 {
  font-size: 28px;
  line-height: 1.18;
  margin-bottom: 10px;
}

.page-hero__copy p {
  max-width: 680px;
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.75;
}

.page-hero__eyebrow {
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.14);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.page-hero__meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.meta-pill {
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  font-size: 13px;
  font-weight: 700;
}

.meta-pill--soft {
  background: rgba(255, 255, 255, 0.1);
}

.filter-section {
  background: rgba(255, 255, 255, 0.92);
  padding: 16px;
  border: 1px solid rgba(215, 229, 251, 0.96);
  border-radius: 24px;
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 设备选择器与重置按钮布局和样式统一 */
.device-selector {
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 28px;
}
.device-selector .van-field {
  flex: 1;
  min-width: 0;
  --van-field-label-width: 48px;
  --van-cell-horizontal-padding: 0px;
  --van-field-input-text-color: var(--text-primary);
}
.device-selector .van-field :deep(.van-field__label) {
  margin-right: 2px;
}
.device-selector .van-field :deep(.van-field__value) {
  min-width: 0;
  flex: 1;
  text-align: left;
}
.clear-device {
  color: var(--brand-700);
  font-size: 13px;
  cursor: pointer;
  padding: 0;
  line-height: 1.2;
  flex-shrink: 0;
}
.date-range-display {
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 28px;
}
.date-range-display .van-field {
  flex: 1;
  min-width: 0;
  --van-field-label-width: 48px;
  --van-cell-horizontal-padding: 0px;
  --van-field-input-text-color: var(--text-primary);
}
.date-range-display .van-field :deep(.van-field__label) {
  margin-right: 2px;
}
.date-range-display .van-field :deep(.van-field__value) {
  min-width: 0;
  flex: 1;
  text-align: left;
}
.clear-date {
  color: var(--brand-700);
  font-size: 13px;
  cursor: pointer;
  padding: 0;
  line-height: 1.2;
  flex-shrink: 0;
}
.type-status-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  min-height: 28px;
  padding-left: 0;
}
.type-selector, .status-selector {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}
.type-selector .van-field,
.status-selector .van-field {
  flex: 1;
  min-width: 0;
  --van-field-label-width: 48px;
  --van-cell-horizontal-padding: 0px;
  --van-field-input-text-color: var(--text-primary);
}
.type-selector .van-field :deep(.van-field__label),
.status-selector .van-field :deep(.van-field__label) {
  margin-right: 2px;
}
.type-selector .van-field :deep(.van-field__value),
.status-selector .van-field :deep(.van-field__value) {
  min-width: 0;
  flex: 1;
  text-align: left;
}
.clear-type,
.clear-status {
  color: var(--brand-700);
  font-size: 13px;
  cursor: pointer;
  padding: 0;
  line-height: 1.2;
  flex-shrink: 0;
}

.van-search {
  margin-bottom: 0px;
  min-height: 6px;
  --van-search-padding: 0 0px;
  --van-search-background: #fff;
}

.van-search .van-field__control {
  font-size: 14px;
  min-height: 8px;
  padding: 2px 0;
}

.van-field {
  min-height: 6px;
  font-size: 14px;
  padding: 2px 0;
  --van-field-label-width: 60px;
  --van-field-label-font-size: 13px;
  --van-field-input-font-size: 13px;
}

@media (max-width: 600px) {
  .type-status-row {
    flex-direction: column;
    gap: 4px;
    padding-left: 0;
  }
}

.stats-section {
  display: flex;
  background: rgba(255, 255, 255, 0.92);
  padding: 16px;
  border: 1px solid rgba(215, 229, 251, 0.96);
  border-radius: 24px;
  box-shadow: var(--shadow-card);
  gap: 10px;
}

.stat-item {
  flex: 1;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 10px;
  border-radius: 18px;
}

.stat-label {
  font-size: 12px;
  color: var(--text-secondary);
}

.stat-value {
  font-size: 20px;
  font-weight: 800;
  color: var(--text-primary);
}

/* 统计区数字颜色样式 */
.stat-value.stat-unverified {
  color: #ff976a;
}
.stat-value.stat-verified {
  color: #07c160;
}
.stat-value.stat-normal {
  color: #07c160;
}
.stat-value.stat-abnormal {
  color: #ee0a24;
}
.stat-value.stat-primary {
  color: #3a7afe;
}

.alarm-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 16px;
}

.alarm-card {
  border-radius: 24px;
  overflow: hidden;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(215, 229, 251, 0.96);
  box-shadow: var(--shadow-card);
}

.alarm-card.unverified-card {
  border-left: 4px solid #ff976a;
  box-shadow: 0 12px 26px rgba(255, 151, 106, 0.18);
}

.alarm-thumb {
  flex-shrink: 0;
  width: 80px;
  height: 100px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  background: #f5f6f8;
  display: flex;
  align-items: center;
  justify-content: center;
}
.alarm-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.no-photo {
  width: 80px;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #999;
  background: #f5f6f8;
  border-radius: 12px;
}

/* 新增底部报警类型标签样式和调整报警时间位置 */
.alarm-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.alarm-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-primary);
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.alarm-time-abs {
  font-size: 12px;
  color: var(--text-muted);
  white-space: nowrap;
  text-align: right;
}
.alarm-footer {
  position: relative;
  padding-top: 24px;
}
.alarm-type-footer {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  justify-content: center;
  width: 100%;
}
.alarm-type-tag-footer {
  padding: 0 16px;
}

.alarm-content {
  padding: 12px 0;
}

.alarm-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-row {
  display: flex;
  align-items: center;
}

.label {
  color: var(--text-secondary);
  font-size: 14px;
  width: 80px;
  flex-shrink: 0;
}

.value {
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
}

.value.description {
  color: #646566;
  font-weight: normal;
}

.alarm-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  border-top: 1px solid #ebedf0;
}
.alarm-actions-left {
  flex: 1;
  display: flex;
  align-items: center;
}
.alarm-actions-right {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
.alarm-btn {
  min-width: 56px;
}
.handle-btn {
  margin-left: 12px;
}

.video-player-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #000;
}

.video-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
}

.video-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
}

.video-header .van-icon {
  cursor: pointer;
  font-size: 20px;
  color: #fff;
}

.video-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.video-player {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.handle-dialog {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.handle-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #ebedf0;
}

.handle-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}

.handle-content {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
}

.alarm-summary {
  margin-bottom: 20px;
  padding: 12px;
  background: #f4f8ff;
  border-radius: 16px;
}

.alarm-summary h4 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
}

.alarm-summary p {
  margin: 0;
  font-size: 14px;
  color: var(--text-secondary);
}

.handle-actions {
  margin-top: 24px;
}

/* 新增footer区域报警类型标签绝对居中样式 */
.alarm-footer-outer {
  position: relative;
  padding-top: 32px;
  padding-bottom: 8px;
}
.alarm-type-footer-in-footer {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  justify-content: center;
  width: 100%;
}
.alarm-type-tag-footer {
  font-size: 14px;
  padding: 0 16px;
}
.alarm-actions-in-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

/* footer三栏布局：左-视频按钮，中-类型标签，右-处理按钮 */
.alarm-footer-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 8px;
  padding: 8px 0 0 0;
}
.footer-col {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}
.footer-col-left {
  justify-content: flex-start;
}
.footer-col-center {
  justify-content: center;
}
.footer-col-right {
  justify-content: flex-end;
}
.alarm-type-tag-footer {
  font-size: 10px;
  padding: 0 16px;
  white-space: nowrap;
}

.alarm-btn {
  white-space: nowrap;
}

/* 设备选择弹窗样式优化 */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #ebedf0;
  background: #fff;
}
.popup-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}
.device-list {
  padding: 16px;
  height: calc(100% - 60px);
  overflow-y: auto;
  background: #fff;
}
.device-selection {
  margin-bottom: 24px;
  position: relative;
  min-height: 200px;
}
.device-selection h4 {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
}
.device-selection .loading-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.binding-actions {
  position: sticky;
  bottom: 0;
  background: white;
  padding-top: 16px;
}
.device-icon {
  color: var(--brand-500);
  font-size: 20px;
}

.stat-item.active {
  background: #eef5ff;
  color: var(--brand-500);
  cursor: pointer;
}
.stat-item {
  cursor: pointer;
}

@media (max-width: 767px) {
  .fence-alarm {
    gap: 14px;
  }

  .page-hero {
    padding: 18px;
    border-radius: 24px;
    flex-direction: column;
  }

  .page-hero__copy h2 {
    font-size: 22px;
  }

  .page-hero__meta {
    flex-direction: column;
    align-items: stretch;
  }

  .date-range-display,
  .device-selector,
  .type-selector {
    gap: 2px;
  }

  .date-range-display .van-field,
  .device-selector .van-field,
  .type-selector .van-field {
    --van-field-label-width: 46px;
  }

  .stats-section {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 6px;
    align-items: stretch;
  }

  .stat-item {
    min-width: 0;
    padding: 10px 4px;
  }

  .stat-label {
    font-size: 11px;
  }

  .stat-value {
    font-size: 16px;
  }

  .alarm-list {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .alarm-time-abs {
    text-align: right;
  }

  .alarm-header {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }

  .footer-col,
  .footer-col-left,
  .footer-col-center,
  .footer-col-right {
    justify-content: flex-start;
  }

  .alarm-footer-row {
    flex-direction: row;
    align-items: center;
  }

  .footer-col-center {
    justify-content: center;
  }

  .footer-col-right {
    justify-content: flex-end;
  }
}
</style>
